<alert></alert>
<alert-timer #alertTimer></alert-timer>
<information></information>
<app-dialog #dialog></app-dialog>
<app-option-selector-dialog #optionSelectorDialog></app-option-selector-dialog>
